<template>
  <nav class="d-flex justify-content-center">
    <ul class="pagination">
      <li :class="{ disabled: currentPage === 1 }">
        <a href="#" class="btn btn-primary" id="firstButton" @click.prevent="goToPage(1)">Primeira</a>
      </li>
      <li :class="{ disabled: currentPage === 1 }">
        <a href="#" class="btn btn-primary" id="previousButton" @click.prevent="goToPage(currentPage - 1)">Anterior</a>
      </li>
      <template v-for="page in pagesToShow">
        <li :class="{ active: page === currentPage }">
          <a href="#" class="btn outline-primary" :id="`page${page}`" @click.prevent="goToPage(page)">{{ page }}</a>
        </li>
      </template>
      <li :class="{ disabled: currentPage === totalPages }">
        <a href="#" class="btn btn-primary" id="nextButton" @click.prevent="goToPage(currentPage + 1)">Próxima</a>
      </li>
      <li :class="{ disabled: currentPage === totalPages }">
        <a href="#" class="btn btn-primary" id="lastButton" @click.prevent="goToPage(totalPages)">Última</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pagesToShow() {
      const maxButtons = 10;
      const sideButtons = 5;
      const buttonsBefore = Math.min(sideButtons, this.currentPage - 1);
      const buttonsAfter = Math.min(sideButtons, this.totalPages - this.currentPage);
      const remainingButtons = maxButtons - buttonsBefore - buttonsAfter;
      const startPage = this.currentPage - buttonsBefore;
      const endPage = this.currentPage + buttonsAfter;

      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        if (i > 0 && i <= this.totalPages) {
          pages.push(i);
        }
      }

      if (pages.length < maxButtons) {
        if (startPage > 1) {
          const diff = Math.min(remainingButtons, startPage - 1);
          for (let i = startPage - diff; i < startPage; i++) {
            pages.unshift(i);
          }
        } else if (endPage < this.totalPages) {
          const diff = Math.min(remainingButtons, this.totalPages - endPage);
          for (let i = endPage + 1; i <= endPage + diff; i++) {
            pages.push(i);
          }
        }
      }

      return pages;
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit('pageChanged', page);
      }
    },
  },
};
</script>
<style scoped>
.btn {
  padding: 11px 15px;
}
.pagination .active a {
  background: rgb(25, 25, 25);
}
</style>
